import { AlpineComponent } from "alpinejs";
// import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

const Header = (): AlpineComponent => ({
  isOpen: false,
  toggle() {
    this.isOpen = !this.isOpen;

    /* this.$nextTick(() => {
      if (this.isOpen) {
        disableBodyScroll(this.$refs.navigation);
      } else {
        enableBodyScroll(this.$refs.navigation);
      }
    });*/
  },

  getPageMaxScroll() {
    // Cross browser page height detection is ugly
    return Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    ) - window.innerHeight; // Subtract viewport height
  },

  scrollTo(event: any) {
    event.preventDefault();

    this.$nextTick(() => {
      const sectionAnchor = event.target.parentElement.getAttribute('href');

      let sectionElement = null;
      if (sectionAnchor) {
        sectionElement = document.getElementById(sectionAnchor.replace('#',''));
      } else {
        sectionElement = document.getElementById(event.target.getAttribute('href').replace('#', ''));
      }

      if (sectionElement) {
        const yOffset = -10; 
        let top = sectionElement.getBoundingClientRect().top + window.scrollY + yOffset;

        // let top = 1000000; // Value larger than maximum scroll
        const maxScroll = this.getPageMaxScroll();

        // Fix for bug on iOS devices
        // When top was larger than maximum page scroll
        // "getBoundingClientRect" would take that value into calculations
        if (top > maxScroll) {
          top = maxScroll;
        }

        sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // window.scrollTo({top: top, behavior: 'smooth'});
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    this.toggle();
  },

  close() {
    this.isOpen = false;
    this.$refs.toggleButton.focus();

    // enableBodyScroll(this.$refs.navigation);
  },

  selectLanguage(event: any) {
    event.preventDefault();

    const language = event.target.value;
    window.location.href = language;
  }

});

export default Header;